import "../index.css";
import { useEffect } from "react";
import Footer from "../components/Footer";
//import { useAuth } from "../auth/context";
import { PageNav } from "../components/PageNav";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   // Update document title
  //   document.title = "Stake Alerts";

  //   // Function to create or update meta tag
  //   const updateMetaTag = (name, content, property = false) => {
  //     const selector = property
  //       ? `meta[property="${name}"]`
  //       : `meta[name="${name}"]`;
  //     let element = document.querySelector(selector);

  //     if (element) {
  //       element.content = content;
  //     } else {
  //       element = document.createElement("meta");
  //       if (property) {
  //         element.setAttribute("property", name);
  //       } else {
  //         element.setAttribute("name", name);
  //       }
  //       element.content = content;
  //       document.head.appendChild(element);
  //     }
  //   };

  //   updateMetaTag(
  //     "description",
  //     "Automate and simplify your sports betting experience across betting houses in real-time."
  //   );
  //   updateMetaTag("keywords", "products, services, shopping, deals");
  // }, []);

  return (
    <div>
      <PageNav />
      <div className="main_div">
        {/* <div className="center_me"></div> */}
        <div className="">
          <ContactForm></ContactForm>
        </div>
      </div>
      <Footer />
    </div>
  );
}
